import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";

function Thirdaboutimg() {

    const captionStyleheader = {
        textAlign: "center",
        padding: "2px",
        marginTop: "2rem",
        marginBottom: "5rem",
      };
    
      const captionTextStyle3 = {
        fontSize: "1.1rem",
        textOverflow: "ellipsis",
        color: "black",
        fontWeight: 600,
        textAlign: "center",
        lineHeight: "2.6",
        marginBottom: "2rem", // Add margin for responsiveness
      };
    
      const imageStyle = {
        objectFit: "cover",
        filter: "opacity(2) brightness(1)",
        width: "100%", // Set the width to 100% to match the card width
      };
    

  return (
    <Container
      fluid
      style={{
        marginBottom: "10px",
        height: "auto",
        marginTop: "100px",
      }}
    >
      <Container
        style={{ padding: "2px", marginTop: "50px", ...captionStyleheader }}
      >
        <Row className="justify-content-center">
          {/* Show two columns on md, lg, and xl screens */}
          <Col xs={12} sm={12} md={12} lg={6}>
            <Container fluid>
              <p
                style={{
                  ...captionTextStyle3,
                  width: "100%",
                  textAlign: "justify",
                  marginBottom: "1rem", // Add margin at the bottom for larger screens
                  marginRight: "0", // Reset right margin
                  marginTop: "1rem"
                }}
              >
                We're forward-thinkers, closely monitoring the pulse of emerging technologies like Artificial Intelligence and their impact on the job market. Our strategies are designed not just to respond to these changes but to anticipate and harness them, ensuring your business stays ahead of the curve. But what truly sets us apart is our belief that our clients' success is our success. Our services are not only affordable and effective, but they're also delivered with a genuine commitment to your growth and well-being. Let's embark on this journey together. A partnership with us is more than a business transaction; it's a shared path to success, fueled by expertise and guided by empathy. Join us, and let's begin our journey towards mutual victory.
              </p>
            </Container>
          </Col>

          {/* Show single column on xs and sm screens */}
          <Col xs={12} sm={12} md={12} lg={5}>
            <Image
              src={process.env.PUBLIC_URL + "/assets/images/Aboutimg2.png"}
              alt=""
              style={{ ...imageStyle, width: "100%" }}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Thirdaboutimg;
